<template>
<div>
    <div v-show="loading">
        <b-icon icon="arrow-clockwise" animation="spin"></b-icon>
        ロード中...
    </div>
    
    <b-alert variant="warning" show v-if="show_application_info">
        <h5> <i class="fas fa-exclamation-triangle"></i> 注意 </h5>
        <h6> 当日は申請手続きがあります。 </h6>
        {{day.application.name}}: {{day.application.application.time}}時間
        <div>
            <a target="blank" :href="'/application/'+day.application.id" class="btn btn-info btn-sm">申請内容確認</a>
        </div>
    </b-alert>

    <nippou-component
        v-if="day.hasNippou && !loading"
        v-model="day.nippou"
        :mode="approving?'approve':'input'"
        :id="'nc-'+username">
    </nippou-component>

    <b-button v-if="!day.hasNippou && !(loading || reloading) && day.need_nippou" @click="createNippou()" variant="success">作成開始</b-button>
    
    <b-alert class="mb-0" variant="warning" :show="!loading && !day.need_nippou">
        <h5> 当日は日報を作成することができません。 </h5>
        理由：{{ getReasonMessage() }}
    </b-alert>
</div>
</template>
<script>
import moment from 'moment'
export default {
    props: {
        username: String,
        approving: Boolean,
        date: String
    },
    data: function() {
        return {
            loading: true,
            reloading: true,
            day: {
                need_nippou: false,
                nippou: {
                    status: 0,
                    status_class: 'secondary',
                    status_name: '...',
                    start_hour: 0,
                    end_hour: 0,
                    breaktime: 0,
                    day: '',
                    media: [],
                    shift: {
                        description: '',
                        shift_group:{
                            description: '',
                        }
                    },
                    user: {
                        name: null,
                        group: {
                            description: null
                        }
                    }
                }
            }
        }
    },
    computed: {
        show_application_info: function() {
            return this.day.need_nippou && this.day.has_application && !this.loading
        }
    },
    methods: {
        getUrl() {
            console.log('getUrl','/api/user/' + this.username + '/nippou/' + this.date)
            return '/api/user/' + this.username + '/nippou/' + this.date
        },
        getNippouDay() {
            this.loading = true
            window.axios.get(this.getUrl()).then(({ data }) => {
                console.log('getNippouDay',data)
                this.day = data.day
            }).catch((response) => {
                console.log(response)
            }).finally(()=>{
                this.loading = false
                this.reloading = false
            })
        },
        createNippou() {
            this.loading = true
            window.axios.post(
                '/api/user/' + this.username + '/nippou',
                { date: this.date }
            ).then(({ data }) => {
                if(data.nid) {
                    this.reloading = true
                    this.getNippouDay()
                }
            }).catch((response) => {
                console.log(response)
            }).finally(()=>{
                this.loading = false
            })
        },
        getReasonMessage() {
            if (this.day.is_holiday) {
                return '休日です。'
            } else {
                if (!this.day.need_nippou && this.day.has_application) {
                    return '８時間以上の「' + this.day.application.name + '」申請がありますす。'
                }
            }
        }
    },
    created() {
        this.getNippouDay()
    }
}
</script>